<script>
    import { onMount, afterUpdate, createEventDispatcher, onDestroy } from "svelte";
    import UserProfileButton from "./UserProfileButton.svelte";
    import ConversationDiv from "./ConversationDiv.svelte";
    import NewChatButton from "./NewChatButton.svelte";
    import ModesToggle from "./ModesToggle.svelte";
    import {
        db,
        activeConversation,
        userID,
        clientUserID,
        splashScreenArtUrl,
        assistantIconUrl,
        selectedMode,
        isModesToggleExpanded,
        emailHash,
        isModesAvailable,
        countDownTimer,
        showCountdown,
        isStatelessUserFlag,
        isCollapsed,
    } from "../stores.js";

    let conversations = [];
//    let isCollapsed = true;
    let interval;


    let clonedButtonVisible = false;
    $: clonedButtonVisible = $isCollapsed;

    // This reactive statement keeps track of the active conversation
    let activeConversationId;
    $: activeConversationId = $activeConversation;

    const dispatch = createEventDispatcher();

    function togglePopupInModesToggle() {
        dispatch("togglePopup");
    }

    //console.log("Inside Sidebar -> UserID:", $userID);
    //console.log("Inside Sidebar -> ClientUserID:", $clientUserID);

    let editIcon = `<svg stroke="#B3B3B3" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" class="icon-sm" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 20h9"></path>
                        <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
                    </svg>`;

    let deleteIcon = `<svg stroke="#B3B3B3" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" class="h-4 w-4" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                  <polyline points="3 6 5 6 21 6"></polyline>
                  <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                  <line x1="10" y1="11" x2="10" y2="17"></line>
                  <line x1="14" y1="11" x2="14" y2="17"></line>
                </svg>`;

    let toggleIcon = `<svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" class="icon-sm text-token-text-primary gizmo:text-token-text-tertiary gizmo:hover:text-token-text-secondary" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="9" y1="3" x2="9" y2="21"></line></svg>`;

    function toggleSidebar() {
        $isCollapsed = !$isCollapsed;
    }

    function selectConversation(convoId) {
        activeConversation.set(convoId);
        console.log("Selected conversation ID:", convoId); // fi logging purposes
    }

    function setupCountdownTimer() {
    if ($userID && $clientUserID && $emailHash) {
        const userDocRef = $db.collection("users")
                              .doc($userID)
                              .collection("deploymentUserData")
                              .doc($clientUserID)
                              .collection("clientSubUsers")
                              .doc($emailHash);
        
        userDocRef.onSnapshot(doc => {
            const data = doc.data();
            if (data.courtesyMessage) {
                const now = new Date().getTime();
                const startTime = new Date(data.timeStart.seconds * 1000); // Convert Firestore Timestamp to JS Date
                const endTime = startTime.getTime() + data.timeLimit * 60000; // Assuming timeLimit is in minutes
                const remainingTime = endTime - now;

                if (remainingTime > 0) {
                    countDownTimer.set(remainingTime);
                } else {
                    countDownTimer.set(0);
                    console.log("Countdown timer expired.");
                }
            }
        }, error => {
            console.error("Error fetching countdown timer data:", error);
        });
    }
}


    function fetchConversations() {
        if ($isStatelessUserFlag) {
            conversations.set([]); // Or set to a default conversation if needed
        } else if ($userID && $clientUserID) {
            const conversationsRef = $db
                .collection("users")
                .doc($userID)
                .collection("deploymentUserData")
                .doc($clientUserID)
                .collection("clientSubUsers")
                .doc($emailHash)
                .collection("conversations");

            conversationsRef
                .orderBy("lastModified", "desc")
                .orderBy("timestamp", "desc")
                .onSnapshot(
                    (snapshot) => {
                        let updatedConversations = [];

                        snapshot.docs.forEach((doc) => {
                            const data = doc.data();
                            updatedConversations.push({
                                id: doc.id,
                                name: data.name ? data.name : doc.id,
                            });
                        });

                        conversations = updatedConversations;

                        // If there's no activeConversation yet, set di first one
                        if (
                            !$activeConversation &&
                            updatedConversations.length > 0
                        ) {
                            activeConversation.set(updatedConversations[0].id);
                            console.log(
                                "Default active conversation ID:",
                                updatedConversations[0].id,
                            );
                        }
                    },
                    (error) => {
                        console.error("Error fetching conversations:", error);
                    },
                );
        }
    }

    /*
    function deleteConversation(conversationID) {
        const confirmDeletion = confirm("Delete chat?");
        if (confirmDeletion) {
            conversations = conversations.filter(
                (c) => c.id !== conversationID
            );
            const conversationToDelete = $db
                .collection("users")
                .doc($userID)
                .collection("deploymentUserData")
                .doc($clientUserID)
                .collection("clientSubUsers")
                .doc($emailHash)
                .collection("conversations")
                .doc(conversationID);
            conversationToDelete.delete();
        }
    }
*/

    function editConversation(conversationID, currentName) {
        const newName = prompt(
            "Enter new name for the conversation:",
            currentName,
        );
        if (newName && newName.trim() !== "") {
            const conversationToUpdate = $db
                .collection("users")
                .doc($userID)
                .collection("deploymentUserData")
                .doc($clientUserID)
                .collection("clientSubUsers")
                .doc($emailHash)
                .collection("conversations")
                .doc(conversationID);
            conversationToUpdate.update({ name: newName.trim() });
        }
    }

    function handleKeyDown(event) {
        if (event.key === "Enter" || event.key === " ") {
            togglePopupInModesToggle();
        }
    }


    // Function to decrement the timer
    function decrementTimer() {
        const interval = setInterval(() => {
            countDownTimer.update(n => {
                if (n <= 0) {
                    clearInterval(interval);
                    return 0;
                }
                return n - 1000;
            });
        }, 1000);
        
        return () => clearInterval(interval); // Cleanup
    }


    onMount(() => {
        // Check if the device is in landscape orientation at mount
        const mediaQuery = window.matchMedia("(orientation: landscape)");
        // If in landscape, set isCollapsed to false
        if (mediaQuery.matches) {
            //isCollapsed = false;
            isCollapsed.set(false);
        }

        // Optional: Adjust behavior when orientation changes after initial load
        const handleOrientationChange = () => {
            //isCollapsed = !mediaQuery.matches; // Collapse if not in landscape
            isCollapsed.set(!mediaQuery.matches)
        };

        mediaQuery.addEventListener('change', handleOrientationChange);

        return () => {
            // Cleanup listener when the component is destroyed
            mediaQuery.removeEventListener('change', handleOrientationChange);
        };
    });

    $: if ($userID && $clientUserID && $emailHash) {
        fetchConversations();
    }

    $: if ($activeConversation) {
        console.log(
            "Active conversation ID (from App.svelte):",
            $activeConversation,
        );
    }

  // Update the countdown every second if showCountdown is true
  $: if ($showCountdown && $countDownTimer > 0) {
    clearInterval(interval); // Clear existing interval to avoid duplicates
    interval = setInterval(() => {
      countDownTimer.update(time => {
        if (time <= 1000) {
          clearInterval(interval); // Stop the interval when time runs out
          return 0;
        }
        return time - 1000; // Decrement time by one second
      });
    }, 1000);
  } else {
    clearInterval(interval); // Ensure no interval runs when countdown shouldn't show
  }

  onDestroy(() => {
    clearInterval(interval); // Cleanup on component destroy
  });


</script>

<div class="container">
<!--    <div class="sidebar {$isCollapsed ? 'collapsed' : ''}"> -->
    <div class="{ $isCollapsed ? 'sidebar collapsed' : 'sidebar' }">

        <div class="top-controls">
            <NewChatButton {conversations} extraClass="new-chat-button" />
            <button class="toggle-button" on:click={toggleSidebar}>
                {@html toggleIcon}
            </button>
            <!-- Placeholder for where the countdown timer will go -->
            {#if $showCountdown}
              <div class="countdown-timer">
                Gpt4 resetTime: {$countDownTimer > 0
                  ? new Date($countDownTimer).toISOString().substr(11, 8)
                  : '00:00:00'}
              </div>
            {/if}
        </div>
        <div class="conversations">
            {#each conversations as conversation}
                <div
                    class="conversation {activeConversationId ===
                    conversation.id
                        ? 'active'
                        : ''}"
                    on:click={() => selectConversation(conversation.id)}
                >
                    <span class="conversation-name" title={conversation.name}
                        >{conversation.name}</span
                    >
                    <div class="conversation-buttons">
                        <button
                            class="edit-btn"
                            on:click|stopPropagation={() =>
                                editConversation(
                                    conversation.id,
                                    conversation.name,
                                )}>{@html editIcon}</button
                        >
                        <button
                            class="delete-btn"
                            on:click|stopPropagation={() =>
                                deleteConversation(conversation.id)}
                            >{@html deleteIcon}</button
                        >
                    </div>
                </div>
            {/each}
        </div>

        <div
            class="modes-toggle-container"
            style:display={$isModesAvailable ? "flex" : "none"}
        >
            <p class="mode-status">
                {$isModesToggleExpanded && $selectedMode
                    ? `${$selectedMode.modeName} ON`
                    : "No modes."}
            </p>
            <ModesToggle />
        </div>

        <UserProfileButton />
    </div>
    <!-- Cloned button, which will become visible when sidebar is collapsed -->
    <button
        class="toggle-button cloned {$isCollapsed ? 'visible' : ''}"
        on:click={toggleSidebar}
        aria-hidden={$isCollapsed ? "false" : "true"}
    >
        {@html toggleIcon}
    </button>
</div>

<style>
    .hidden {
        display: none;
    }

    .container {
        display: flex;
        position: relative; /* Added to position the cloned button absolutely within this container */
    }

    .sidebar {
        width: 360px;
        height: 100vh;
        background-color: var(--sidebar-bg);
        /*        border-right: 1px solid #e1e4e8;*/
        overflow-x: hidden;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        transition: margin-left 0.3s; /* Animate margin-left */
        margin-left: 0; /* Start with no negative margin */
    }

    .conversations {
        overflow-y: auto; /* Enables vertical scrolling */
        flex-grow: 1; /* Takes up all available space */
        /* Rest of the styles */
    }

    .sidebar.collapsed {
        margin-left: -360px; /* Slide to the left to hide */
    }

    .top-controls {
        display: flex;
        justify-content: space-between;
        padding: 10px;
    }

    .countdown-timer {
        padding: 5px 10px;
        margin-left: 10px; /* Add some spacing between this and the toggle button */
        background-color: #007bff; /* Or whatever matches your sidebar's theme */
        color: white;
        border-radius: 5px;
        font-size: 0.875rem;
    }


    .conversation-name {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        flex-grow: 1; /* Ensures it takes up available space */
    }

    .conversation-buttons {
        display: flex;
        flex-shrink: 0; /* Prevents buttons from shrinking */
    }

    .conversation {
        display: flex;
        align-items: center; /* Aligns items vertically in the center */
        justify-content: space-between; /* Spaces out the name and buttons */
    }

    .toggle-button {
        flex: 1; /* Takes 25% of the space */
        height: 40px;
        width: 40px;
        border: 1px solid #4d4d4f;
        border-radius: 6px;
        color: var(--sidebarconvodiv-text);
        background-color: var(--sidebar-bg);
        cursor: pointer;
    }

    .toggle-button.cloned {
        position: absolute; /* Position the cloned button absolutely */
        top: 0; /* Align the top of the button with the container */
        right: 0; /* Align the button to the right, outside the sidebar */
        z-index: 10; /* Make sure it's above other elements */
        opacity: 0;
        pointer-events: none; /* Button is not clickable when invisible */
        transition:
            opacity 0.3s,
            right 0.3s,
            color 0.3s,
            background-color 0.3s; /* Transition all properties smoothly */
        border: 0px;
    }

    .toggle-button.cloned.visible {
        width: 60px;
        padding-top: 10px;
        opacity: 1;
        pointer-events: auto; /* Button is clickable when visible */
        right: -60px; /* Adjust this value to move the button to the desired visible position when sidebar is collapsed */
        color: var(--primary-text);
        background-color: var(--primary-bg);
        transition:
            opacity 0.3s,
            right 0.3s,
            color 0.3s,
            background-color 0.3s;
    }

    .conversation {
        padding: 0.75rem;
        /*      border: 1px solid #e1e4e8; */
        color: var(--sidebarconvodiv-text);
        border-radius: 5px;
        /*        margin-bottom: 5px; */
        cursor: pointer;
        transition: background-color 0.2s;
    }

    .conversation:hover {
        background-color: #292e31;
    }

    .active {
        background-color: #343541;
        color: white;
    }

    .edit-btn:active,
    .delete-btn:active {
        background-color: #747780;
        border: 1px solid #797575;
    }

    .edit-btn,
    .delete-btn {
        margin-left: 5px;
        background-color: transparent;
        border: 0px solid #ccc;
        cursor: pointer;
        border-radius: 10px;
    }

    .modes-toggle-container {
        display: flex;
        align-items: center;
        justify-content: flex-end; /* Aligns to the right */
        padding: 10px;
    }

    .mode-status {
        margin-right: 10px;
        color: white;
    }

/* Media query for devices in portrait orientation */
@media (orientation: portrait) {
    .sidebar {
        width: 100vw; /* Sets the sidebar width to 100% of the viewport width */
    }

    .sidebar.collapsed {
        margin-left: -100vw; /* Ensures it slides out completely */
    }
}
</style>
